import React from "react";
import { Col, ControlLabel, FormGroup, Radio } from "react-bootstrap";
import { Control } from "react-redux-form";

export default () => (
  <FormGroup controlId="userGender">
    <div>
      <ControlLabel>Gender*</ControlLabel>
    </div>
    <div className="row-no-padding">
      <Col lg={3}>
        <Control.radio inline model=".gender" value="male" component={Radio}>
          Male
        </Control.radio>
      </Col>
      <Col lg={3}>
        <Control.radio
          inline
          model=".gender"
          value="female"
          component={Radio}
        >
          Female
        </Control.radio>
      </Col>
      <Col lg={3}>
        <Control.radio inline model=".gender" value="other" component={Radio}>
          Other
        </Control.radio>
      </Col>
      <Col lg={3}>
        <Control.radio
          inline
          model=".gender"
          value="prefer_not_to_say"
          component={Radio}
        >
          Prefer not to say
        </Control.radio>
      </Col>
    </div>
  </FormGroup>
);



// WEBPACK FOOTER //
// ./src/components/about-you/user-gender-selector.jsx